import { render, staticRenderFns } from "./scene5Mobile.vue?vue&type=template&id=19c623e8&scoped=true&"
import script from "./scene5Mobile.vue?vue&type=script&lang=js&"
export * from "./scene5Mobile.vue?vue&type=script&lang=js&"
import style0 from "./scene5Mobile.vue?vue&type=style&index=0&id=19c623e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c623e8",
  null
  
)

export default component.exports